import './App.css';

function App() {
  return (
    <div className="App">
<header>Privacy Policy</header>
<br/>
<header>General</header>

<p>
The Privacy Policy outlines the practices for collecting, using, and disclosing user-provided information when you interact with this application.
By using the app, you accept the terms of this privacy policy.
The Not Now app does not collect any personally identifiable information from its users. 
The application does not require access to the Internet or specific authorization to access your personal information.</p>
<br/>
<header>Collection of data</header>

<p>The ability to share links from other apps and websites is part of the functionality.
SQLite's databases are used to store user data locally on users device.
There are no third-party services or servers that can see this data,
although please keep in mind that links saved by our app may be traceable by the apps and websites they came from.
I cannot ensure the privacy policies of these apps and websites, and users should review their privacy policies before using them.

I strongly discourage the storage of passwords within the application.</p>
<br/>
<header>Changes to the Policy</header>

<p>I reserve the right to modify or revise this privacy policy without prior notice.

Last modified: 15 May 2023</p>
<br/>
<header>Contact</header>

<p>If you have any questions or concerns regarding our privacy policy, please contact me at notnow-service@gmail.com.</p>
    </div>
  );
}

export default App;
